import React from "react";
import PremiumResourcePage, { resourceMoney } from "../../../Components/Dashboard/PremiumResourcePage";
import BillsUpdate from "./BillsUpdate";

function Bills({ navigation }) {
  return (
    <PremiumResourcePage
      navigation={navigation}
      title="Bills"
      subtitle="Manage vendor bills, purchases, and outstanding payables."
      createRoute="BillsNew"
      createLabel="+ New Bill"
      fetchEndpoint="/fetchBill"
      documentType="bill"
      deleteEndpoint="/deleteByBillNumber/:id"
      deleteKey="billNumber"
      totalKey="total"
      transformRows={(rows) =>
        rows.map((row) => ({
          ...row,
          billNumber: row.billNumber || row.billsNumber,
          billsNumber: row.billsNumber || row.billNumber,
        }))
      }
      renderEdit={(row, handleCancel) => (
        <BillsUpdate
          billsNumber={row.billNumber || row.billsNumber}
          handleCancel={handleCancel}
        />
      )}
      columns={[
        { key: "billsDate", label: "Date" },
        {
          key: "billNumber",
          label: "Bill #",
          render: (row) => (
            <button className="premium-link" type="button">
              {row.billNumber || row.billsNumber || "-"}
            </button>
          ),
        },
        { key: "vendorName", label: "Vendor Name" },
        { key: "orderNumber", label: "Order Number" },
        { key: "total", label: "Amount", className: "premium-money", render: (row) => resourceMoney(row.total) },
      ]}
    />
  );
}

export default Bills;
